import { render, staticRenderFns } from "./_favorites.vue?vue&type=template&id=79286c6a&"
import script from "./_favorites.vue?vue&type=script&lang=ts&"
export * from "./_favorites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79286c6a')) {
      api.createRecord('79286c6a', component.options)
    } else {
      api.reload('79286c6a', component.options)
    }
    module.hot.accept("./_favorites.vue?vue&type=template&id=79286c6a&", function () {
      api.rerender('79286c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/mypages/_favorites.vue"
export default component.exports